import { useEffect } from "react";

/**
 * 팝업 공통 틀 — '파랑 절제' 규칙(2026-10-02 사용자 결정, 문의 #125 세율 팝업에서 시작).
 *
 *  1. 머리는 흰 바탕 · 제목 검정 굵게 · 보조 줄 회색 · ✕ 회색. 머리를 파랑으로 칠하지 않는다.
 *  2. 파랑은 두 곳에만 — ① 그 팝업의 핵심 숫자·값 하나 ② 주 버튼 하나(있을 때만).
 *     단 세율 숫자는 세번 상세 표와 같은 주황(`RATE_COLOR`)으로 쓴다(사용자 결정 2026-10-02 — 세율은 어디서나 같은 색).
 *  3. 나가는 링크·자료 칩·표시·선은 회색/검정(`modalChip`·`modalQuietLink`). 굵기와 밑줄로 구분한다.
 *  4. 강조 행은 노랑·주황 대신 옅은 회색 바탕 + 왼쪽 검은 선(`modalHitRow`). 주황·초록 금지(팔레트 규칙).
 *  5. 카드에 minHeight 0 — `.audit-root` 의 min-height:100% 가 카드를 화면 높이로 늘린다.
 *  6. Esc·바깥 클릭으로 닫는다. alert/confirm 은 쓰지 않는다.
 *
 * 새 팝업은 이 틀을 쓰고, 파랑이 필요하면 `modalKeyValue`(핵심 값)·`modalPrimaryButton`(주 버튼)만 쓴다.
 */
export const modalChip = {
  fontSize: 12,
  padding: "4px 10px",
  border: "1px solid var(--audit-border)",
  borderRadius: 12,
  color: "var(--audit-text)",
  textDecoration: "none",
  background: "transparent",
};
export const modalQuietLink = {
  color: "var(--audit-text-muted)",
  fontSize: 12,
  textDecoration: "underline dotted",
  textUnderlineOffset: 2,
};
/** 세율 숫자 색 — 세번 상세(.hsk-sheet .hsk-rate)와 같다. 팔레트의 주황 금지 규칙의 유일한 예외. */
export const RATE_COLOR = "#d9730d";
export const modalKeyValue = { color: "var(--audit-accent)", fontWeight: 800 };
export const modalPrimaryButton = {
  background: "var(--audit-accent)",
  color: "#fff",
  border: 0,
  borderRadius: 8,
  padding: "7px 16px",
  fontSize: 13,
  fontWeight: 700,
  cursor: "pointer",
  textDecoration: "none",
  display: "inline-block",
};
export const modalHitRow = {
  background: "var(--audit-bg-subtle, #f3f4f6)",
  boxShadow: "inset 3px 0 0 var(--audit-text)",
};

export default function ModalShell({ title, subtitle = null, onClose, maxWidth = 640, label = null, children, footer = null, testId = null }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    <div
      onClick={onClose}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="audit-root"
        role="dialog"
        aria-label={label || (typeof title === "string" ? title : undefined)}
        data-testid={testId || undefined}
        style={{
          background: "var(--audit-bg-elevated, #fff)",
          borderRadius: 12,
          maxWidth,
          width: "100%",
          minHeight: 0,
          maxHeight: "86vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          boxShadow: "0 12px 40px rgba(0,0,0,0.25)",
        }}
      >
        <div style={{ display: "flex", alignItems: "flex-start", gap: 8, padding: "14px 16px 12px", borderBottom: "1px solid var(--audit-border)", flexShrink: 0 }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 16, fontWeight: 800, color: "var(--audit-text)", overflowWrap: "anywhere" }}>{title}</div>
            {subtitle && <div style={{ fontSize: 12, color: "var(--audit-text-muted)", marginTop: 2 }}>{subtitle}</div>}
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="닫기"
            style={{ border: "none", background: "transparent", color: "var(--audit-text-muted)", fontSize: 18, cursor: "pointer", lineHeight: 1, padding: 2 }}
          >
            ✕
          </button>
        </div>
        <div style={{ padding: 16, overflowY: "auto", minHeight: 0 }}>{children}</div>
        {footer && (
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, padding: "10px 16px", borderTop: "1px solid var(--audit-border)", flexShrink: 0 }}>{footer}</div>
        )}
      </div>
    </div>
  );
}
